import React  from 'react';

import useTextCorrection from "../../hooks/useTextCorrection";

import {
  TableBody
} from "./index.style";

interface DetailsTable {
  headings: {},
  tableData: object,
}

const DetailsTable: React.FC<DetailsTable> = ({headings, tableData}) => {
  const {filterEmpty, correctDateFormat} = useTextCorrection();

  return (
    <TableBody>
      <tbody>
      {Object.keys(headings).map((header: string) => {
        let component = tableData[headings[header]];
        if(header.includes("csvonly")) return;
        if(header.toLowerCase().includes('amount')) component = "$" + component;
        component = correctDateFormat(component,header);
        return (
          <tr>
            <th>{header}</th>
            {filterEmpty(component)}
          </tr>
        );
      })}
      </tbody>
    </TableBody>
  );

};

export default DetailsTable;